var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import Vue from 'vue';
import { Action, namespace, State } from 'vuex-class';
import { Component, Watch, Prop } from 'vue-property-decorator';
import { PublicBotHelper } from 'packages/bot/PublicBotHelper';
import BotSpeechBubble from 'ui/v1/bot/BotSpeechBubble.vue';
import TypingIndicator from 'ui/v1/loaders/TypingIndicator.vue';
import { container } from 'tsyringe';
import { LanguageService } from 'services/LanguageService';
import BotAvatar from 'ui/v1/bot/BotAvatar.vue';
import { MediaAsset } from 'packages/media/MediaAsset';
import { EntityBuilder } from '@decahedron/entity';
import { BrandingSettings } from 'packages/company/entities/BrandingSettings';
import anime from 'animejs/lib/anime.es';
import CookiePreferenceFooter from 'apps/public/src/components/CookiePreferenceFooter.vue';
import ENV from 'config/env';
import tailwind from '../../../../tailwind.config';
var botModule = namespace('publicBot');
var BotView = /** @class */ (function (_super) {
    __extends(BotView, _super);
    function BotView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.botHelper = new PublicBotHelper(_this.$store);
        _this.langService = container.resolve(LanguageService);
        _this.conversationSource = null;
        _this.botColor = '';
        _this.botAvatar = null;
        _this.previousScrollPosition = null;
        _this.previousContentHeight = null;
        _this.privatePolicyLink = null;
        _this.fixBot = true;
        _this.loading = true;
        _this.askForPreference = false;
        return _this;
    }
    Object.defineProperty(BotView.prototype, "computedGroups", {
        get: function () {
            if (this.renderStack.length === 0) {
                return [];
            }
            var messageGroups = [];
            var buffer = __spreadArray([], this.renderStack);
            var currentGroup = [buffer.shift()];
            buffer.forEach(function (instruction) {
                if (currentGroup[0].type === instruction.type) {
                    currentGroup.push(instruction);
                }
                else {
                    messageGroups.push(currentGroup);
                    currentGroup = [instruction];
                }
            });
            messageGroups.push(currentGroup);
            return messageGroups;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BotView.prototype, "latestMessage", {
        get: function () {
            return this.renderStack[this.renderStack.length - 1];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BotView.prototype, "isInIframe", {
        get: function () {
            return window.location !== window.parent.location;
        },
        enumerable: false,
        configurable: true
    });
    BotView.prototype.scrollHandle = function () {
        var container = this.$refs.botContainer;
        // Check if scroll action up, and if container height remains the same, which means its user scrolling, not dom shrinking.
        if (this.$refs.botContainer.scrollTop < this.previousScrollPosition
            && this.previousContentHeight === this.$refs.scrollable.scrollHeight) {
            this.fixBot = false;
        }
        else if ( // If scroll action is downwards, and user is semi close (50px threshold) away from the bottom, fix the bot again.
        this.$refs.botContainer.scrollTop > this.previousScrollPosition
            && container.scrollTop > container.scrollHeight - container.offsetHeight - 50) {
            this.fixBot = true;
        }
        this.previousContentHeight = this.$refs.scrollable.scrollHeight;
        this.previousScrollPosition = this.$refs.botContainer.scrollTop;
    };
    BotView.prototype.created = function () {
        var _this = this;
        window.postMessage('component created', '*');
        window.addEventListener('message', function (event) {
            // Ignore all other events (eg. hotjar and intercom) except for the one that sends the source
            if (event.data === 'component created' || event.data.source) {
                // If bot is running in iframe
                _this.conversationSource = window.location !== window.parent.location ? event.data.source : window.location.href;
                _this.startNewConversation({
                    botId: _this.botId,
                    source: _this.conversationSource,
                }).then(function (response) {
                    _this.getBrandingSettings(response.company_id);
                    _this.botAvatar = EntityBuilder.buildOne(MediaAsset, response.avatar);
                    _this.botColor = response.color ? response.color : tailwind.theme.colors.fuchsia;
                    _this.botHelper.establishConnection(response.id);
                    _this.langService.setLanguage(response.lang);
                    _this.getPrivacyPolicy(response.company_id);
                    _this.loading = false;
                    _this.privatePolicyLink = ENV.APPS.PRIVACY.CANDIDATE_URL(response.lang, response.company_id);
                });
            }
        });
    };
    BotView.prototype.sendInput = function (message) {
        this.botHelper.sendResponse(message);
    };
    BotView.prototype.instructionValue = function (instruction) {
        var _a;
        return (_a = instruction === null || instruction === void 0 ? void 0 : instruction.data) === null || _a === void 0 ? void 0 : _a.value;
    };
    BotView.prototype.autoScroll = function (newVal) {
        var _this = this;
        var timeoutDuration = newVal[newVal.length - 1][0].type === 'collect' ? 600 : 0;
        if (this.fixBot) {
            setTimeout(function () {
                anime({
                    targets: _this.$refs.botContainer,
                    scrollTop: _this.$refs.botContainer.scrollHeight,
                    easing: 'easeInOutQuad',
                    duration: 700,
                });
            }, timeoutDuration);
        }
    };
    var _a;
    __decorate([
        botModule.Action,
        __metadata("design:type", Function)
    ], BotView.prototype, "startNewConversation", void 0);
    __decorate([
        botModule.Mutation,
        __metadata("design:type", Function)
    ], BotView.prototype, "shiftInstruction", void 0);
    __decorate([
        botModule.State,
        __metadata("design:type", Array)
    ], BotView.prototype, "instructionBufferStack", void 0);
    __decorate([
        botModule.State,
        __metadata("design:type", Array)
    ], BotView.prototype, "renderStack", void 0);
    __decorate([
        botModule.State,
        __metadata("design:type", String)
    ], BotView.prototype, "isTypingMessage", void 0);
    __decorate([
        State,
        __metadata("design:type", typeof (_a = typeof BrandingSettings !== "undefined" && BrandingSettings) === "function" ? _a : Object)
    ], BotView.prototype, "branding", void 0);
    __decorate([
        Action,
        __metadata("design:type", Function)
    ], BotView.prototype, "getBrandingSettings", void 0);
    __decorate([
        Action,
        __metadata("design:type", Function)
    ], BotView.prototype, "getPrivacyPolicy", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], BotView.prototype, "botId", void 0);
    __decorate([
        Watch('computedGroups'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BotView.prototype, "autoScroll", null);
    BotView = __decorate([
        Component({
            components: {
                BotAvatar: BotAvatar,
                BotSpeechBubble: BotSpeechBubble,
                TypingIndicator: TypingIndicator,
                CookiePreferenceFooter: CookiePreferenceFooter,
            },
            metaInfo: function () {
                return {
                    title: 'Jobibot',
                    bodyAttrs: {
                        class: ['bg-light-gray'],
                    },
                };
            },
        })
    ], BotView);
    return BotView;
}(Vue));
export default BotView;
